/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import ReservationEvent from '../../event/ReservationEvent'
import { AccommodationInvoiceState } from '../state/AccommodationInvoiceState'

class AccommodationInvoicesStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of(new AccommodationInvoiceState())
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.fetchInvoices:
        return List(payload.invoices.map(r => new AccommodationInvoiceState(r)))

      default:
        return state
    }
  }
}

export default new AccommodationInvoicesStore()
